import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import SwitchWithLabel from "../../common/CustomSwitch";
import CustomTextField from "../../common/CustomTextField";
import { RadioGroupWithLabel } from "../../common/RadioGroup";
import { MIN_VALUE, MAX_VALUE_CONSTRAINTS } from "../../common/constants";
import appConstants from "../../../../../../../appConstants";

const ShipmentDetails = ({
  classes,
  priorityShipmentsList,
  editInfo,
  errorInfo,
  excessiveShipmentList,
  handleChange,
}) => {
  return (
    <div id="shipmentDetails">
      <Typography variant="subtitle1" className={classes.headerLabel}>
        SHIPMENT DETAILS
      </Typography>
      <RadioGroupWithLabel
        rowLabel="Expedite Shipment"
        onChange={handleChange("priority")}
        options={priorityShipmentsList}
        value={editInfo.priority}
      />
      <SwitchWithLabel
        rowLabel="Food"
        onChange={handleChange("isFood")}
        value={editInfo.isFood}
      />
      <RadioGroupWithLabel
        rowLabel="Excessive Length"
        onChange={handleChange("isExcessiveLength")}
        options={excessiveShipmentList}
        value={editInfo.isExcessiveLength}
      />
      <Collapse in={editInfo.isExcessiveLength === appConstants.EXCESSIVE_SHIPMENT.YES}>
        <CustomTextField
          className={classes.fullWidth}
          id="excessiveProLength"
          handleChange={handleChange("excessiveProLength")}
          value={editInfo.excessiveProLength}
          error={errorInfo.excessiveProLength}
          label="Pro Length (Feet)"
          inputProps={{
            min: MIN_VALUE.PICKUP_PRO_FORM.EXCESSIVE_LENGTH,
            max: MAX_VALUE_CONSTRAINTS.PICKUP_PRO_FORM.EXCESSIVE_LENGTH,
          }}
          type="number"
        />
        <span className={classes.infoText}>
          Pro must be 8 feet (or) less than or equal to trailer length.
        </span>
      </Collapse>
      <SwitchWithLabel
        rowLabel="Freezable"
        onChange={handleChange("isFreezable")}
        value={editInfo.isFreezable}
      />
      {/* <SwitchWithLabel
        rowLabel="Ammunition"
        onChange={handleChange("isAmmunition")}
        value={editInfo.isAmmunition}
      /> */}
    </div>
  );
};

export default withStyles(styles)(ShipmentDetails);
